export default class createUserOverlay {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/modal/createUser.html'),
            scope: {
                show: '=',
                account: '='
            },
            controller: CreateUserCtrl,
            controllerAs: 'user'
        }
    }
};

class CreateUserCtrl {
    constructor($scope, $filter, Events, User, Sogeti) {
        this._scope = $scope;
        this._translator = $filter('translate');
        
        this.userRepo = User;
        this.eventHandler = Events;
        this.sogeti = Sogeti;
        this.errors = [];
        
        this.createMore = false;
        this.user = {};

        $(document).keyup((e) => {
            if (e.keyCode == 27) {
                this._scope.show = false;
                this._scope.$apply(); // Close modal on escape.
            }
        });

        this._scope.$watch('account', (account) => {
            if (account) {
                this.setRole();
            }
        });
    }

    save() {
        this.errors = [];
        this.userRepo.create(this.user).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:USER_CREATED'));
            
            this._scope.$emit('setting:newUser');
            
            if (! this.createMore) {
                this.toggleShow(); // Close modal.
            } else {
                this.user = {};
            }
        }, (error) => {
            this.handleErrors(error.data);
        });
    };

    handleErrors(data) {
        if (data.errors) {
            Object.keys(data.errors).forEach(key => {
               this.errors.push(data.errors[key]);
            });
        } else {
            this.eventHandler.flashEvent('error', data.message || this._translator('GLOBAL:ERROR:DEFAULT'));
        }

    }

    static toggleCreateMore() {
        this.createMore = $('#createMoreBtn').is(':checked');
    };

    toggleShow() {
        this._scope.show = ! this._scope.show;
    };

    setRole() {
        this.user.role = 3; // Admin role id
    }
}
